import { IStatusPanelComp, IStatusPanelParams } from '@ag-grid-community/core'
import {
  ChangeDetectorRef,
  ComponentFactoryResolver,
  ComponentRef,
  Injector,
} from '@angular/core'
import { IssueCountStatusComponent } from './issue-count-status.component'

export class IssueCountStatusBar implements IStatusPanelComp {
  private params?: IStatusPanelParams
  private componentRef!: ComponentRef<IssueCountStatusComponent>

  /** @internal */
  readonly paginationChangedListener = () => this.onPaginationChanged()
  /** @internal */
  readonly selectionChangedListener = () => this.onSelectionChanged()

  init(params: IStatusPanelParams): void {
    this.params = params
    const resolver = params.context.resolver as ComponentFactoryResolver
    const cd = params.context.changeDetector as ChangeDetectorRef

    const injector = Injector.create({
      providers: [
        {
          provide: ChangeDetectorRef,
          useValue: cd,
        },
        {
          provide: 'AgGridApi',
          useValue: params,
        },
      ],
    })
    this.componentRef = resolver
      .resolveComponentFactory(IssueCountStatusComponent)
      .create(injector)
    this.componentRef.instance.updateCounts()

    params.api.addEventListener(
      'paginationChanged',
      this.paginationChangedListener,
    )
    params.api.addEventListener(
      'selectionChanged',
      this.selectionChangedListener,
    )
  }

  getGui(): HTMLElement {
    return this.componentRef.location.nativeElement
  }

  destroy() {
    this.params?.api.removeEventListener(
      'paginationChanged',
      this.paginationChangedListener,
    )
    this.params?.api.removeEventListener(
      'selectionChanged',
      this.selectionChangedListener,
    )
  }

  /** @internal */
  onPaginationChanged() {
    this.componentRef.instance.updateCounts()
  }

  /** @internal */
  onSelectionChanged() {
    this.componentRef.instance.updateCounts()
  }
}
